import { weeklyCalendar } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  calendar: { ...weeklyCalendar, uuid: "" },
};

function handleRequest(state: State) {
  return { ...state, request: setRequestStateToPending() };
}

function handleSuccess(
  state: State,
  { calendar }: Boundaries["retrievePersonalWeeklyCalendar"]["success"],
) {
  return {
    ...state,
    request: setRequestStateToSuccess(),
    calendar,
  };
}

function handleFailure(state: State) {
  return { ...state, request: setRequestStateToFailure() };
}

const reduceState = createStateReducer(initialState, {
  [events.retrievePersonalWeeklyCalendarRequested]: handleRequest,
  [events.retrievePersonalWeeklyCalendarSucceeded]: handleSuccess,
  [events.retrievePersonalWeeklyCalendarFailed]: handleFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
